import React from 'react';

const NotAuthorized = () => {
  return <h1>You are not authorized to view this page.</h1>;
};

export default NotAuthorized;
